import React from 'react';

const RoadmapOption4 = () => {
  const products = [
    {
      name: 'QuickSync Me',
      color: 'emerald',
      icon: '/qs-share-logo.svg',
      tagline: 'Secure sharing and collaboration',
      live: 'QuickSync Me V1',
      phases: [
        { title: 'New design and architecture', status: 'completed', version: 'QuickSync Me V2' },
        { title: 'Front-end/back-end development', status: 'completed' },
        { title: 'Conclusion of Filecoin cohort', status: 'completed' },
        { title: 'Public Launch V2', status: 'completed', timeline: 'Jan' },
        { title: 'Continuous improvements', status: 'in-progress', timeline: 'Q1' },
        { title: 'Rich collaborative tools', status: 'upcoming', timeline: 'Q2' },
        { title: 'Monetization', status: 'upcoming', timeline: 'Q2' },
        { title: 'In-session AI agents', status: 'upcoming', timeline: 'Q2-Q3' },
        { title: 'Beyond files & docs', status: 'upcoming', tag: 'Beyond', timeline: 'Q3-Q4' },
      ]
    },
    {
      name: 'StageX',
      color: 'purple',
      icon: 'https://customer-assets.emergentagent.com/job_9c600170-5d16-447d-bfe0-1d0de6d7d09f/artifacts/b6z8aocx_StageX.png',
      tagline: 'Live streams for free speech and interactionFi',
      live: 'StageX V1',
      phases: [
        { title: 'User login via socials/email', status: 'completed', version: 'StageX V2' },
        { title: 'In space live reactions', status: 'completed' },
        { title: 'Homepage redesign & discovery', status: 'completed' },
        { title: 'Implementing in-system credits', status: 'in-progress', timeline: 'Jan' },
        { title: 'Tips/Donations', status: 'in-progress', timeline: 'Feb' },
        { title: 'Record space and share snippets', status: 'upcoming', timeline: 'Q1' },
        { title: 'Premium subscription', status: 'upcoming', timeline: 'Q1' },
        { title: 'Book a host, fund raising, token gated events', status: 'upcoming', version: 'StageX V3', timeline: 'Q2' },
        { title: 'Native in-session buys', status: 'upcoming', timeline: 'Q2' },
        { title: 'Screen & Video Share', status: 'upcoming', timeline: 'Q2' },
        { title: 'Collaborative trading streams', status: 'upcoming', tag: 'Beyond', timeline: 'Q3-Q4' },
      ]
    },
    {
      name: 'QS Framework',
      color: 'amber',
      icon: 'https://customer-assets.emergentagent.com/job_9c600170-5d16-447d-bfe0-1d0de6d7d09f/artifacts/wg56q37t_Framework%20QS.png',
      tagline: 'The full stack privacy workspaces infrastructure',
      live: 'APIs',
      liveExtra: ' is live & monetized',
      phases: [
        { title: 'Rooms APIs', status: 'completed' },
        { title: 'Chat & Files APIs', status: 'completed' },
        { title: 'Identity/Rules APIs', status: 'completed' },
        { title: 'Real time events & Voice', status: 'in-progress', timeline: 'Jan' },
        { title: 'Micropayments system', status: 'in-progress', timeline: 'Feb' },
        { title: 'Open source GitHub', status: 'upcoming', timeline: 'Feb' },
        { title: 'PayKit SDK', status: 'upcoming', timeline: 'Mar' },
        { title: 'Additional workspace capabilities', status: 'upcoming', timeline: 'Q1' },
        { title: 'SDKs', status: 'upcoming', timeline: 'Q2' },
        { title: 'Developer dashboard', status: 'upcoming', timeline: 'Q2' },
        { title: 'Unified identity', status: 'upcoming', tag: 'Beyond', timeline: 'Q3' },
      ]
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      emerald: {
        bg: 'bg-emerald-500',
        bgLight: 'bg-emerald-100',
        text: 'text-emerald-600',
        border: 'border-emerald-500',
        gradient: 'from-emerald-500 to-teal-500',
        line: 'from-emerald-500'
      },
      purple: {
        bg: 'bg-purple-500',
        bgLight: 'bg-purple-100',
        text: 'text-purple-600',
        border: 'border-purple-500',
        gradient: 'from-purple-500 to-pink-500',
        line: 'from-purple-500'
      },
      amber: {
        bg: 'bg-amber-500',
        bgLight: 'bg-amber-100',
        text: 'text-amber-600',
        border: 'border-amber-500',
        gradient: 'from-amber-500 to-orange-500',
        line: 'from-amber-500'
      }
    };
    return colors[color];
  };

  return (
    <section className="relative bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-medium text-sm mb-2 block">ROADMAP</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Converging Paths
          </h2>
        </div>

        {/* Main Visual */}
        <div className="relative">
          {/* SVG Connection Lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ zIndex: 0 }}>
            {/* Curved paths from each product to convergence */}
            <defs>
              <linearGradient id="emeraldGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#10b981" stopOpacity="0.5" />
                <stop offset="100%" stopColor="#10b981" stopOpacity="0.1" />
              </linearGradient>
              <linearGradient id="purpleGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#a855f7" stopOpacity="0.5" />
                <stop offset="100%" stopColor="#a855f7" stopOpacity="0.1" />
              </linearGradient>
              <linearGradient id="amberGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.5" />
                <stop offset="100%" stopColor="#f59e0b" stopOpacity="0.1" />
              </linearGradient>
            </defs>
          </svg>

          {/* Product Tracks */}
          <div className="grid md:grid-cols-3 gap-8 mb-16 relative z-10">
            {products.map((product, productIndex) => (
              <div key={productIndex} className="relative">
                {/* Product Header */}
                <div className="flex items-center gap-3 mb-1">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${getColorClasses(product.color).gradient} p-2.5 flex items-center justify-center shadow-lg`}>
                    <img src={product.icon} alt={product.name} className="w-full h-full object-contain filter brightness-0 invert" />
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">{product.name}</h3>
                </div>

                {/* Tagline */}
                {product.tagline && (
                  <p className="text-sm text-gray-500 mb-3 pl-15">{product.tagline}</p>
                )}

                {/* Live Indicator */}
                {product.live && (
                  <div className="mb-6 flex items-center gap-2 relative pl-6">
                    <span className="absolute left-[5px] flex h-2.5 w-2.5">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
                    </span>
                    <span className="text-sm text-gray-600"><span className="font-semibold text-green-600">{product.live}</span>{product.liveExtra || ' is live'}</span>
                  </div>
                )}

                {/* Vertical Track */}
                <div className="relative pl-6">
                  {/* Vertical Line */}
                  <div className={`absolute left-2 top-0 bottom-0 w-0.5 bg-gradient-to-b ${getColorClasses(product.color).line} to-gray-200`}></div>

                  {/* Phases */}
                  <div className="space-y-4">
                    {product.phases.map((phase, phaseIndex) => (
                      <div key={phaseIndex} className="relative">
                        {/* Version Label */}
                        {phase.version && (
                          <div className={`mb-2 inline-block px-3 py-1 rounded-full text-xs font-semibold ${getColorClasses(product.color).bg} text-white`}>
                            {phase.version}
                          </div>
                        )}
                        {/* Tag Label */}
                        {phase.tag && (
                          <div className="mb-2 inline-block px-3 py-1 rounded-full text-xs font-semibold bg-gray-800 text-white">
                            {phase.tag}
                          </div>
                        )}
                        
                        {/* Card with centered dot */}
                        <div className="relative flex items-center">
                          {/* Dot - centered vertically with card */}
                          <div className={`absolute -left-4 w-3 h-3 rounded-full border-2 border-white shadow ${
                            phase.status === 'completed' ? getColorClasses(product.color).bg :
                            phase.status === 'in-progress' ? 'bg-amber-500 animate-pulse' : 'bg-gray-300'
                          }`}></div>

                          {/* Card */}
                          <div className={`flex-1 bg-white rounded-xl border-2 p-4 transition-all hover:shadow-md ${
                            phase.status === 'in-progress' ? `${getColorClasses(product.color).border} shadow` : 'border-gray-200'
                          }`}>
                            <div className="flex items-center justify-between">
                              <span className="font-semibold text-gray-900">{phase.title}</span>
                              <div className="flex items-center gap-2">
                                {phase.timeline && (
                                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full font-medium">{phase.timeline}</span>
                                )}
                                {phase.status === 'completed' && (
                                  <svg className="w-5 h-5 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                )}
                                {phase.status === 'in-progress' && (
                                  <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Active</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapOption4;
